import { Link } from "react-router-dom";
import { MapPin, Globe, MessageCircle, Mail, Phone } from "lucide-react";
import StarRating from "./StarRating";

export default function ProfileCard({ profile }) {
  return (
    <Link
      to={`/profil/${profile.slug || profile.id}`}
      data-testid={`profile-card-${profile.id}`}
      className="card-surface card-hover overflow-hidden group flex flex-col"
    >
      <div className="aspect-[4/3] sm:aspect-[16/10] bg-secondary overflow-hidden relative">
        {profile.photo_url ? (
          <img
            src={profile.photo_url}
            alt={profile.name}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-primary text-4xl font-display font-bold">
            {profile.name?.[0]}
          </div>
        )}
        {profile.featured && (
          <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary text-white text-[10px] uppercase tracking-wider font-semibold rounded-full">
            En vedette
          </span>
        )}
      </div>
      <div className="p-5 flex flex-col gap-2 flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display font-semibold text-lg text-foreground leading-tight">{profile.name}</h3>
        </div>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <MapPin className="w-3.5 h-3.5" />
          <span>{profile.city || "—"}{profile.province ? `, ${profile.province}` : ""}</span>
        </div>
        <p className="text-sm text-muted-foreground line-clamp-2 mt-1">{profile.description}</p>
        <div className="flex items-center justify-between mt-auto pt-3">
          <StarRating value={profile.avg_rating} count={profile.review_count} />
          <div className="flex gap-1.5 text-muted-foreground">
            {profile.whatsapp && <MessageCircle className="w-4 h-4" />}
            {profile.email && <Mail className="w-4 h-4" />}
            {profile.phone && <Phone className="w-4 h-4" />}
            {profile.website && <Globe className="w-4 h-4" />}
          </div>
        </div>
      </div>
    </Link>
  );
}
